import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

import { userService } from '../services/user.service';


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    errorMsg: {
        margin: theme.spacing.unit,
        color: 'red',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
});


class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            error: '',
            loading: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        const { username, password } = this.state;
        // stop here if form is invalid
        if (!(username && password)) {
            return;
        }
        this.setState({  loading: true }, () => {
            userService.login(username, password)
                .then(
                    user => {
                        //const { from } = this.props.location.state || { from: { pathname: "/" } };
                        //this.props.history.push(from);
                        this.props.history.push('/');

                    },
                    error => this.setState({ error, loading: false })
                );
        });
    }

    render() {
        const { classes } = this.props;
        const { username, password, error } = this.state;

        return (
            <main className={classes.main}>
                <Paper className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Prihlásenie
                    </Typography>
                    <form className={classes.form} onSubmit={this.handleSubmit} >
                        <FormControl margin="normal" required fullWidth>
                            <InputLabel htmlFor="username">Používateľské meno</InputLabel>
                            <Input id="username" name="username" autoFocus value={username} onChange={this.handleChange} />
                        </FormControl>
                        <FormControl margin="normal" required fullWidth>
                            <InputLabel htmlFor="password">Heslo</InputLabel>
                            <Input name="password" type="password" id="password" autoComplete="current-password" value={password} onChange={this.handleChange} />
                        </FormControl>
                        {error &&
                            <InputLabel className={classes.errorMsg} > <ErrorOutlinedIcon /> {error}</InputLabel>
                        }
                        <Button
                            type="submit" disabled={this.state.loading}
                            fullWidth
                            variant="contained"
                            color="secondary"
                            className={classes.submit}
                        >
                            Prihlásiť
                            </Button>
                    </form>
                </Paper>
            </main>
        );
    }
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginPage);


// WEBPACK FOOTER //
// ./src/components/LoginPage.js